<template>
    <OutstandingTransactionList 
        :accountNumber="accountNumber"
        :customerFirstName="customerFirstName"
        :customerLastName="customerLastName"
        :customerEmail="customerEmail"
        :customerAddresses="customerAddresses"
        :phoneNumber="phoneNumber"
        :defaultBillingAddress="defaultBillingAddress"
    />
    <TransactionSearch :accountNumber="accountNumber"/>
</template>

<script>
    import OutstandingTransactionList from '../components/OutstandingTransactionList.vue';
    import TransactionSearch from '../components/TransactionSearch.vue';

    export default {
        name: 'AccountTransactions',
        props: {
            accountNumber: {
                type: String,
                required: true
            },
            customerFirstName: {
                type: String,
                required: true
            },
            customerLastName: {
                type: String,
                required: true
            },
            customerEmail: {
                type: String,
                required: true
            },
            customerAddresses: {
                type: String,
                required: true
            },
            phoneNumber: {
                type: String,
                required: true
            },
            defaultBillingAddress: {
                type: Object,
                required: true
            }
        },
        components: {
            OutstandingTransactionList,
            TransactionSearch
        },
    };
</script>